import React from 'react';
import type { LogoMakerIntegration } from '../../context/LogoMakerContext';
import LogoMakerProviders from '../../context/LogoMakerContext/LogoMakerProviders';
import { LoggedOutLogoMakerBase, type LoggedOutLogoMakerBaseProps } from './LoggedOutLogoMakerBase';

export interface LoggedOutLogoMakerProps extends LoggedOutLogoMakerBaseProps {
    showBackButton?: boolean;
    integration?: LogoMakerIntegration;
    isTransparent?: boolean;
    isSticky?: boolean;
}

export const LoggedOutLogoMaker = ({
    showSeoLinks,
    showJoinLink,
    showBackButton,
    integration,
    isTransparent,
    isSticky,
}: LoggedOutLogoMakerProps) => (
    <LogoMakerProviders
        showBackButton={showBackButton}
        integration={integration}
        isTransparent={isTransparent}
        isSticky={isSticky}
    >
        <LoggedOutLogoMakerBase showSeoLinks={showSeoLinks} showJoinLink={showJoinLink} />
    </LogoMakerProviders>
);

export default LoggedOutLogoMaker;
